import {type FC, useEffect, useState} from 'react';
import type {StreamingInfo} from '../types';
import {CurrentTimeIndicator, EventBlock, TimelineContainer, TimelineWrapper} from '../types/TimelineBar.Styled.ts';
import {hourToMinutes} from '../../../utils/DateUtil.ts';

interface TimelineBarProps {
    events: StreamingInfo[];
}

const regionColors: Record<string, string> = {
    default: '#a3a3a3',
    인천시: '#4ade80',
    미추홀: '#60a5fa',
    강화군: '#f472b6',
};

const TimelineBar: FC<TimelineBarProps> = ({events}) => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000 * 60);
        return () => clearInterval(interval);
    }, []);

    // UX 를 위해 방송 1시간을 200px 로 잡음
    const PIXELS_PER_MINUTE = 200 / 60;

    const getLeftOffset = (start: string) => {
        // 기준: 09:00 = 540분
        return (hourToMinutes(start) - 540) * PIXELS_PER_MINUTE;
    };

    const getWidth = (start: string, end: string) => {
        return (hourToMinutes(end) - hourToMinutes(start)) * PIXELS_PER_MINUTE;
    };

    const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();

    const offsetX = (currentMinutes - 540) * PIXELS_PER_MINUTE;

    return (
        <TimelineWrapper>
            <CurrentTimeIndicator />
            <TimelineContainer $offsetX={offsetX}>
                {events.map((event, idx) => {
                    const color = regionColors[event.region ?? 'default'];
                    return (
                        <EventBlock
                            key={idx}
                            $isLive={event.isLive}
                            $left={getLeftOffset(event.start_time)}
                            $width={getWidth(event.start_time, event.end_time)}
                            $color={color}
                        >
                            <div className="time">
                                {event.start_time} - {event.end_time}
                            </div>
                            <div className="title">{event.title}</div>
                        </EventBlock>
                    );
                })}
            </TimelineContainer>
        </TimelineWrapper>
    );
};

export default TimelineBar;
